module.exports = __webpack_public_path__ + "img/file.3e2e0184.png";